import {
  SET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  USER_PROFILE_LOADING,
  USER_PROFILE_ERROR,
  UPDATE_PROFILE_FIRST_ADDRESS,
  OPEN_MODAL_UPDATE_PERSONAL_DATA,
  CLOSE_MODAL_UPDATE_PERSONAL_DATA,
} from '../types/ProfileTypes';

const initialState = {
  profile: '',
  loading: false,
  error: false,
  openModalUpdatePersonalData: true,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PROFILE_LOADING:
      return { ...state, loading: true };
    case SET_USER_PROFILE:
      return { ...state, loading: false, profile: action.profile };
    case UPDATE_USER_PROFILE:
      return { ...state, loading: false };
    case USER_PROFILE_ERROR:
      return { ...state, loading: false, error: true };
    case UPDATE_PROFILE_FIRST_ADDRESS:
      return { ...state, profile: { ...state.profile, ...action.profile } };
    case OPEN_MODAL_UPDATE_PERSONAL_DATA:
      return {
        ...state,
        openModalUpdatePersonalData: true,
      };
    case CLOSE_MODAL_UPDATE_PERSONAL_DATA:
      return {
        ...state,
        openModalUpdatePersonalData: false,
      };
    default:
      return state;
  }
};

export default profileReducer;
